/**************************************************
 * Nombre:       Seccion_Programas
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_FECHA_DINERO,
    CASILLA_IMG
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {AssignmentInd, Description, Feed, FormatListBulleted, ManageSearch} from "@mui/icons-material";
import {ESTADOSPEDIDOS} from "../../Constantes";
import {useNavigate} from "react-router";
import Dialogo_Programas from "../Dialogos/Programas/Dialogo_Programas";
import Dialogo_Programas_Informacion from "../Dialogos/Programas/Dialogo_Programas_Informacion";
import Dialogo_Programas_Razones from "../Dialogos/Programas/Dialogo_Programas_Razones";
import Dialogo_Programas_Perfil from "../Dialogos/Programas/Dialogo_Programas_Perfil";
import Dialogo_Programas_Plan from "../Dialogos/Programas/Dialogo_Programas_Plan";


const Seccion_Programas = () => {
    const navigate = useNavigate();
    const {props, setData, setNumeroFilas, cargarNuevamente} = useObtenerColleccionTabla2025({coleccion: 'programas'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Programas,
        titulo: 'Detalles del programa',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPrograma, abrir: abrirPrograma} = useDialogo({
        Componente: Dialogo_Programas_Informacion,
        titulo: 'Detalles del programa',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoRazones, abrir: abrirRazones} = useDialogo({
        Componente: Dialogo_Programas_Razones,
        titulo: 'Razones del programa',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPerfil, abrir: abrirPerfil} = useDialogo({
        Componente: Dialogo_Programas_Perfil,
        titulo: 'Perfil del egresado',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPlan, abrir: abrirPlan} = useDialogo({
        Componente: Dialogo_Programas_Plan,
        titulo: 'Plan de estudios',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        switch (id) {
            case 'detalles':
                abrir(data)
                break;
            case 'informacion':
                abrirPrograma(data)
                break;
            case 'razones':
                abrirRazones(data)
                break;
            case 'perfil':
                abrirPerfil(data)
                break;
            case 'plan':
                abrirPlan(data)
                break;
            case 'inscritos':
                navigate(`/Potenciales/${data.id}`)
                break;
            default :
                abrir(data)
        }
    }

    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoPrograma/>

                <DialogoRazones/>

                <DialogoPerfil/>

                <DialogoPlan/>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de Oferta Academica'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Programas

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]


const datosCabecera = [
    {
        nombre: 'Img',
        direccion: 'left',
        propiedad: 'img',
        size: 52,
        tipo: CASILLA_IMG
    },
    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS
    },
    {
        nombre: 'Fecha Inicio',
        direccion: 'left',
        propiedad: 'valor',
        fecha: 'fechaInicio',
        tipo: CASILLA_FECHA_DINERO

    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOSPEDIDOS
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Informacion',
        id: 'informacion',
        icono: Feed
    },
    {
        nombre: 'Razones',
        id: 'razones',
        icono: Description
    },
    {
        nombre: 'Perfil',
        id: 'perfil',
        icono: AssignmentInd
    },
    {
        nombre: 'Plan de estudios',
        id: 'plan',
        icono: FormatListBulleted
    },
]

